(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAddNoteDialogController', ContratAddNoteDialogController);

    ContratAddNoteDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat'];

    function ContratAddNoteDialogController($scope, $uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.contrat = null;
        vm.isLoading = true;
        vm.request = {
            contratId: null,
            note: null
        };
        vm.save = save;
        vm.clear = clear;

        if (entity && entity.$promise && angular.isFunction(entity.$promise.then)) {
            entity.$promise.then(applyEntity, function() {
                vm.isLoading = false;
            });
        } else {
            applyEntity(entity);
        }

        function save() {
            if (!vm.request.contratId) {
                return;
            }
            vm.isSaving = true;
            Contrat.addNote(vm.request, function() {
                $scope.$emit('wamasysApp:contratUpdate', vm.contrat);
                vm.isSaving = false;
                $uibModalInstance.close();
            }, function() {
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function applyEntity(loadedEntity) {
            vm.contrat = loadedEntity || {};
            vm.request.contratId = vm.contrat.id || null;
            vm.isLoading = false;
        }
    }
})();
